/**
 * 自动聚焦指令
 * 用于 Element Plus input/textarea 组件自动获取焦点
 */
export default {
    mounted(el: HTMLElement) {
        if (!el) return;
        if (el.className.indexOf('el-textarea') !== -1) {
            setTimeout(() => {
                (el.children[0] as HTMLElement)?.focus();
            }, 0);
        } else if (el.className.indexOf('el-input') !== -1) {
            setTimeout(() => {
                (el.children[0]?.children[0] as HTMLElement)?.focus();
            }, 0);
        }
    },
};
